import React, { FunctionComponent } from 'react';
import {
  CardListItem,
  CardListItemProps
} from 'record-it-components/cardList/CardListItem/CardListItem';
import { CardListItemIconButton } from 'record-it-components/cardList/CardListItemIconButton/CardListItemIconButton';
import { CardListItemIconLink } from 'record-it-components/cardList/CardListItemIconLink/CardListItemIconLink';
import { CardListItemTitle } from 'record-it-components/cardList/CardListItemTitle/CardListItemTitle';
import { useModalOpened } from 'record-it-components/hooks/useModalOpened/useModalOpened';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { TimeTrackingActivityCompilation } from '../../../classes/entities/TimeTrackingActivityCompilation/timeTrackingActivityCompilationTypes';
import { iconConfigurations } from '../../../classes/icon/iconConfigurations';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useTimeTrackingActivityCompilationDeleteHandler } from '../../../hooks/entity/deleteHandler/useTimeTrackingActivityCompilationDeleteHandler';
import { EditTimeTrackingActivityCompilationDialog } from '../EditTimeTrackingActivityCompilationDialog/EditTimeTrackingActivityCompilationDialog';

export type TimeTrackingActivityCompilationListItemProps =
  PropsWithoutChildren<CardListItemProps> & {
    timeTrackingActivityCompilation: TimeTrackingActivityCompilation;
  };

export const TimeTrackingActivityCompilationListItem: FunctionComponent<TimeTrackingActivityCompilationListItemProps> =
  React.memo((props) => {
    const { timeTrackingActivityCompilation, ...remainingProps } = prepareProps(
      { props, ignoreChildren: true }
    );

    const {
      open: openEditDialog,
      close: closeEditDialog,
      modalProps
    } = useModalOpened({ closeOnBackDropClick: true });

    const handleDeleteClick = useTimeTrackingActivityCompilationDeleteHandler(
      timeTrackingActivityCompilation
    );

    return (
      <>
        <CardListItem {...remainingProps}>
          <CardListItemTitle data-testid="TimeTrackingActivityCompilationListItem.Title">
            {timeTrackingActivityCompilation.name}
          </CardListItemTitle>
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.deleteIcon}
            onClick={handleDeleteClick}
            data-testid="TimeTrackingActivityCompilationListItem.DeleteButton"
          ></CardListItemIconButton>
          <CardListItemIconButton
            {...iconConfigurations.prefixed.listItem.editInDialogIcon}
            onClick={openEditDialog}
            data-testid="TimeTrackingActivityCompilationListItem.EditButton"
          ></CardListItemIconButton>
          <CardListItemIconLink
            {...iconConfigurations.prefixed.listItem.enterListItem}
            to={RoutePaths.adminTimeTrackingActivities(
              timeTrackingActivityCompilation.id
            )}
          ></CardListItemIconLink>
        </CardListItem>
        <EditTimeTrackingActivityCompilationDialog
          {...modalProps}
          timeTrackingActivityCompilation={timeTrackingActivityCompilation}
          onAccept={closeEditDialog}
          data-testid="TimeTrackingActivityCompilationListItem.EditDialog"
        ></EditTimeTrackingActivityCompilationDialog>
      </>
    );
  });
